/* eslint-disable react/jsx-props-no-spreading */
import { faPen } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ClickAwayListener, Stack, Tooltip, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useController, useFormContext } from 'react-hook-form';

import TextField, { TextFieldProps } from './TextField';

function TextFieldEditable(props: TextFieldProps) {
  const { name, label } = props;
  const { control } = useFormContext();
  const { field } = useController({ control, name });
  const [editMode, setEditMode] = useState(false);

  let jsx = (
    <Stack direction="row" spacing={1}>
      <Typography variant="h5">{field.value}</Typography>
      <Stack sx={{ cursor: 'pointer' }} onClick={() => setEditMode(true)} pt="5px" aria-label={label}>
        <Tooltip title="Edit">
          <FontAwesomeIcon icon={faPen} color="#8C8C8C" fontSize="16px" />
        </Tooltip>
      </Stack>
    </Stack>
  );
  if (editMode) {
    jsx = (
      <ClickAwayListener onClickAway={() => setEditMode(false)}>
        <div>
          <TextField {...props} />
        </div>
      </ClickAwayListener>
    );
  }

  return jsx;
}

export default TextFieldEditable;
